module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_6000.af8aa129.png";